import { IDataSource } from "../../../Global/Base/DataSources/Interfaces";
import { CancellationToken } from "../../../Global/Base/Promises/CancellationTokenSource";
import { OWObject } from "../../../OW.Remoting/Remoting/DataTypes/OWObject";
import { IExtendedObjectOperation } from "../../../OW.Remoting/Remoting/OWManagerInterfaces";
import { INewRow, SaveResultData } from "./EditableDBDataSource";

export interface IObjectDataSource extends IDataSource {
    /**
     * Volitelná funkce umožňující řídit, zda se má objekt uvolnit
     */
    objectDisposePredicate?: (objForDispose: OWObject) => boolean;
    /**
     * Vrátí objekt s daným id
     * @param id Id požadovaného objektu
     * @param extendedOperations Operace, které se mají provést ihned po založení nové instance aplikačního záznamu
     * @param forceLoad Zda se má vynutit znovunačtení objektu ze služby (přeskočí cache)
     * @param ct Token umožňující zrušení procesu
     */
    getObject(id: string, extendedOperations?: IExtendedObjectOperation[], forceLoad?: boolean, ct?: CancellationToken): Promise<OWObject>;
    /**
     * Uloží změněné objekty
     * @param saveOnlyKeys Pokud je vyplněno, uloží jen objekty v této kolekci
     * @param forceApplyUpdates Použije applyUpdates na objektu i pokud je nevalidní na klientské straně
     * @param ct Token umožňující zrušení procesu
     */
    saveObjects(saveOnlyKeys?: string[], forceApplyUpdates?: boolean, ct?: CancellationToken): Promise<SaveResultData[]>;
    /**
     * Vytvori nový řádek
     * @param extendedOperations Operace, které se mají provést ihned po založení nové instance aplikačního záznamu
     * @param objectName Název třídy, jejíž záznam se má založit, pokud není specifikovaný, tak se vezme třída nastavená na DataSource
     * @param attrNames Seznam atributů, které se mají z nového záznamu přečíst
     * @param ct Token umožňující zrušení procesu
     */
    newRow(extendedOperations?: IExtendedObjectOperation[], objectName?: string, attrNames?: string[], ct?: CancellationToken): Promise<INewRow>;

    /**
     * Smaže objekt podle klíče.
     * @param id Id požadovaného objektu
     * @param ct Token umožňující zrušení procesu
     */
    deleteObject(id: string, ct?: CancellationToken): Promise<any>;
}

export class IObjectDataSource {
    private static _properties = [] as string[];
    private static _methods = ["getObject", "saveObjects", "newRow", "deleteObject"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function");
    }
}
